import { Outlet, useLoaderData } from '@tanstack/react-router';
import { useEffect } from 'react';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AutoManagedCampaignTabs } from '@anytag/shared-organisms';
import { AutoManagedRouter } from '../../../app/_private-routes/auto-managed';
import { AutoManagedCampaignDetailsProvider } from './auto-managed-campaign-details-context';

export const AutoManagedCampaignDetails = () => {
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { loading, networkStatus, autoManagedCampaign, errorMessage } = useLoaderData({
    from: '/_private-routes/auto-managed/$id'
  }) as Awaited<ReturnType<(typeof AutoManagedRouter)['/_private-routes/auto-managed/$id']['1']['loader']>>;

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(t(errorMessage), { variant: 'error' });
      navigate({ to: '/auto-managed' });
    }
  }, [errorMessage]);

  return (
    <RenderDataWithFallback loading={loading && networkStatus === 1}>
      {autoManagedCampaign ? (
        <AutoManagedCampaignDetailsProvider value={{ autoManagedCampaign }}>
          <div>
            <div>
              <Header />
              <AutoManagedCampaignTabs id={autoManagedCampaign.id} />
            </div>
            <Outlet />
          </div>
        </AutoManagedCampaignDetailsProvider>
      ) : null}
    </RenderDataWithFallback>
  );
};
